export const educationDetails = [
  {
    label: '10th',
    value: 'tenth',
  },
  {
    label: '12th',
    value: 'twelfth',
  },
  {
    label: 'Diploma',
    value: 'diploma',
  },
  {
    label: 'PG Diploma',
    value: 'p_g_diploma',
  },
  {
    label: 'Undergraduate',
    value: 'ug',
  },
  {
    label: 'Postgraduate',
    value: 'pg',
  },
  {
    label: 'Professional Degree',
    value: 'phd',
  },
]

export const boardList = [
  {
    name: 'CBSE',
  },
  {
    name: 'ISC',
  },
  {
    name: 'ICSE',
  },
  {
    name: 'NIOS',
  },
  {
    name: 'UP Board',
  },
  {
    name: 'JKBOSE',
  },
]
export const countryData = [
  {
    id: '1',
    value: 'India',
  },
]

export const stateData = [
  {
    id: '1',
    value: 'Tamilnadu',
  },
]

export const buttonDetails = [
  {
    label: 'Percentage',
    value: 'percentage',
  },
  {
    label: 'CGPA',
    value: 'cgpa',
  },
]

export const semMarksList = [
  {
    label: '1st Semester',
    name: 'semester_1',
  },
  {
    label: '2nd Semester',
    name: 'semester_2',
  },
  {
    label: '3rd Semester',
    name: 'semester_3',
  },
  {
    label: '4th Semester',
    name: 'semester_4',
  },
  {
    label: '5th Semester',
    name: 'semester_5',
  },
  {
    label: '6th Semester',
    name: 'semester_6',
  },
  {
    label: '7th Semester',
    name: 'semester_7',
  },
  {
    label: '8th Semester',
    name: 'semester_8',
  },
]
